import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { BasicInformations } from '../models/basic-informations.model';

@Injectable({
    providedIn: 'root'
})
export class SaveDraftService {
    private info: Subject<Boolean> = new BehaviorSubject<Boolean>(null);

    get info$() {
        return this.info.asObservable();
    }

    addInfo() {
        this.info.next(true);
    }

}